<template>
  <div>
    {{ media }}
    <br>
    <v-btn @click="fetchData()">Neu Laden</v-btn>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      media: ''

    }
  },
  created () {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData()
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      const app = this

      axios.get('/api/v1/getmedialibrary')
    .then(resp => {
      console.log(resp)
      app.media = resp.data
    })
    .catch(error => {
      console.log(error.response)
    })
    }

  }

}
</script>